// src/pages/Projects.jsx
import styled from "styled-components";
import { LiaEyeSolid } from "react-icons/lia";
import { FaGithub } from "react-icons/fa";

const Projects = () => {
  const projects = [
    {
      title: "Guitarature – Online Guitar Learning Platform",
      techstack: "React, Node.js, Express.js, MongoDB, JWT Auth",
      desc: "Role-based online platform for students, teachers, and admins to manage guitar lessons and progress tracking.",
      img: "/projects/guitarpro.png",
      tags: ["Full Stack", "Education", "MERN"],
      live: "https://guitar-pro.vercel.app",
      github: "https://github.com/NishalDinesh124/Guitar-pro",
    },
    {
      title: "Real-Time Chat Application",
      techstack: "React, Node.js, Express.js, MongoDB, Socket.IO",
      desc: "A responsive web chat app with real-time messaging, login, and user authentication using Socket.IO.",
      img: "/projects/talk.png",
      tags: ["Socket.IO", "Chat", "MERN"],
      live: "https://chat-app-nu-gules.vercel.app",
      github: "https://github.com/NishalDinesh124/Chat-App",
    },
    {
      title: "PlayNext – Online Music Player",
      techstack: "React, Node.js, Express.js, MongoDB, Apple Music API",
      desc: "An online music player where users can play, pause, and like songs, integrated with Apple Music API.",
      img: "/projects/playnext.png",
      tags: ["Music", "API", "React"],
      live: "https://play-next-music-player.vercel.app",
      github: "https://github.com/NishalDinesh124/PlayNext-Music-Player",
    },
    {
      title: "ND Cart – E-Commerce Platform",
      techstack: "React, Node.js, Express.js, MongoDB, Razorpay",
      desc: "A complete e-commerce platform with product browsing, filtering, cart, buy now, and online payment integration.",
      img: "/projects/ndcart.png",
      tags: ["E-Commerce", "Razorpay", "MERN"],
      live: "https://www.nd-cart.store",
      github: "https://github.com/NishalDinesh124/ND-shopping-cart",
    },
  ];

  return (
    <Wrapper>
      <h1>Projects</h1>
      <div className="underline" />
      <div className="grid">
        {projects.map((p, i) => (
          <div className="card" key={i}>
            <div className="img-container">
              <img src={p.img} alt={p.title} />
              <div className="overlay">
                <a href={p.live} target="_blank" rel="noopener noreferrer">
                  <LiaEyeSolid/>
                </a>
                <a href={p.github} target="_blank" rel="noopener noreferrer">
                  <FaGithub/>
                </a>
              </div>
            </div>
            <h3>{p.title}</h3>
            <p>{p.desc}</p>
            <div className="tags">
              {p.tags.map((t, idx) => (
                <span key={idx}>{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default Projects;

const Wrapper = styled.div`
  color: ${({ theme }) => theme.text};
  padding: 2em 0em;

  @media (max-width: 768px) {
    padding: 6rem 2rem 3rem 2rem;
  }

  .underline {
    width: 50px;
    height: 4px;
    background-color: ${({ theme }) => theme.accent};
    margin: 10px 0 30px;
    border-radius: 5px;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 25px;
  }

  .card {
    background: ${({ theme }) => theme.card};
    border-radius: 15px;
    padding: 20px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    position: relative;
    overflow: hidden;

    &:hover {
      transform: translateY(-5px);
    }

    .img-container {
      position: relative;
      width: 100%;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        border-radius: 10px;
        transition: 0.3s ease;
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        transition: 0.3s ease;

        a {
          background: ${({ theme }) => theme.accent};
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          padding: 8px 16px;
          border-radius: 8px;
          font-weight: 500;
          border-radius: 15px;
          text-decoration: none;
          transition: 0.3s;

          &:hover {
            background: ${({ theme }) => theme.accent}cc;
          }
          svg{
            font-size: 30px;
          }
        }
      }

      &:hover img {
        filter: blur(3px) brightness(0.8);
        transform: scale(1.05);
      }

      &:hover .overlay {
        opacity: 1;
      }
    }

    h3 {
      margin-top: 15px;
      margin-bottom: 10px;
      font-size: 1.1rem;
    }

    p {
      font-size: 0.95rem;
      opacity: 0.9;
    }

    .tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 10px;

      span {
        font-size: 0.85rem;
        background: ${({ theme }) => theme.accent}22;
        padding: 4px 10px;
        border-radius: 8px;
      }
    }
  }
`;
